import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
    root: theme.isZendesk
        ? {
            paddingLeft: 0,
            paddingRight: 0,
        }
        : {},
}));
